import { ExpenseCollection, ExpenseLimitSettingCollection } from "types";

export const GetBalanceAmount = (
  /** 経費申請情報 */
  expenses: ExpenseCollection[],
  /** expenseLimitSetting.documentId */
  id: string,
  /** 使用するユーザーのID */
  userId: string,
  /** 経費枠情報 */
  expenseLimitSetting: ExpenseLimitSettingCollection
): number => {
  /** 自分の経費申請で、承認済以降のステータス且つ使用する経費枠が指定のものを取得 */
  const targets = expenses
    .filter(f => f.userId === userId)
    .filter(f => f.expenseLimitSettingId === id)
    .filter(
      f =>
        f.status === "approval" ||
        f.status === "paid" ||
        f.status === "received"
    );
  const result = (expenseLimitSetting.amountLimit ?? 0) - sumAmount(targets);
  return result;
};

/**
 * 経費の合計を算出
 * @param expenses 経費申請情報
 * @returns
 */
const sumAmount = (/** 経費申請情報 */ expenses: ExpenseCollection[]) => {
  let sum = 0;
  for (let i = 0, len = expenses.length; i < len; i++) {
    sum += expenses[i].totalAmount ?? 0;
  }
  return sum;
};
